import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import ListenLanding from "@/pages/ListenLanding";
import OpsIQLogos from "@/pages/OpsIQLogos";
import OpsIQ from "@/pages/OpsIQ";
import AboutPage from "@/pages/AboutPage";
import WhatWeDoPage from "@/pages/WhatWeDoPage";
import SolutionsPage from "@/pages/SolutionsPage";
import IndustriesPage from "@/pages/IndustriesPage";
import MethodologyPage from "@/pages/MethodologyPage";
import WhyOpsIQPage from "@/pages/WhyOpsIQPage";
import ContactPage from "@/pages/ContactPage";
import BookConsultationPage from "@/pages/BookConsultationPage";
import WhatsAppFab from "@/components/opsiq/WhatsAppFab";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<OpsIQ />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/what-we-do" element={<WhatWeDoPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/industries" element={<IndustriesPage />} />
          <Route path="/methodology" element={<MethodologyPage />} />
          <Route path="/why-opsiq" element={<WhyOpsIQPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/book" element={<BookConsultationPage />} />
          <Route path="/listen" element={<ListenLanding />} />
          <Route path="/opsiq-logos" element={<OpsIQLogos />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <WhatsAppFab />
      <Toaster position="bottom-right" richColors theme="dark" />
    </div>
  );
}

export default App;
